import React from "react";
import { Container, Row, Col, Image, Button,} from "react-bootstrap";
// import profile from "./img/profile.jpg"
import SocialRow from "./components/SocialRow";
import { FiExternalLink } from "react-icons/fi";
// import PortfolioItem from './components/PortfolioItem';

export default function Home() {
  // const Portfolio = () => {
  //   const projects = [
  //     { imagePath: 'https://cdn.myportfolio.com/9c0c32ffbfb6bec1105e5a0038d455f6/a1b3743f-75c8-49a6-b93a-53b72e811fce_rw_600.jpg?h=710e7944e4896592c45f212ee954ae73', title: 'Grimy Sticky Stuff Remover 3D product feature', description: 'Detailed description of Project One' },
  //     { imagePath: 'img/proj/project2.jpg', title: 'Project Two', description: 'Detailed description of Project Two' },

  //   ];

  //   return (
  //     <div className="portfolio">
  //       {projects.map((project, index) => (
  //         <PortfolioItem
  //           key={index}
  //           imagePath={project.imagePath}
  //           title={project.title}
  //           description={project.description}
  //         />
  //       ))}
  //     </div>
  //   );
  // };

  return (
    <>
      {/* <Portfolio /> */}

      <Container fluid style={{ backgroundColor: "#666", minHeight: "30px" }}>
        <SocialRow />
      </Container>

      <Container
        fluid
        className="p-5 bg-dark text-white d-flex flex-column justify-content-around align-items-center"
        style={{ minHeight: "90vh" }}
      >
        {/* <p className='display-1' style={{minWidth:"100"}}>james gerhold</p> */}

        <div className="justify-content-center d-flex flex-column">
          <a
            className="h5 link-light text-decoration-none"
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.linkedin.com/in/jamesgerhold"
          >
            <FiExternalLink /> LinkedIn
          </a>

          <a
            className="h5 link-light text-decoration-none"
            rel="noopener noreferrer"
            target="_blank"
            href="https://www.mediavelocity.com"
          >
            <FiExternalLink /> Mediavelocity
          </a>

          <a
            className="h5 text-white text-decoration-none link-opacity-10-hover"
            rel="noopener noreferrer"
            target="_blank"
            href="https://jamesgerhold.myportfolio.com/"
          >
            <FiExternalLink /> myportfolio.com
          </a>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1429.41 274">
          <path
            d="M37.93 75.32V224.7c0 16.77-6.71 24.25-22.96 24.25-2.06 0-5.68-.52-7.48-1.03v-6.97c2.32.77 4.9 1.03 7.22 1.03 11.87 0 15.48-5.68 15.48-17.29V75.32h7.74Zm0-32.51h-7.74V25.52h7.74v17.29Zm114.03 149.12v-9.03h-.52c-6.45 14.96-23.99 28.38-50.57 28.38S58.3 197.86 58.3 175.16c0-29.15 23.74-35.86 51.6-39.22 32.77-3.61 42.05-6.45 42.05-20.64v-2.06c0-21.93-12.38-33.28-37.15-33.28-26.06 0-40.76 10.58-42.57 33.8h-8C66.04 90.02 80.74 73 114.8 73c29.67 0 44.89 14.19 44.89 40.51v77.66c0 9.8 3.87 12.64 9.8 12.64 2.58 0 5.16-1.03 6.97-1.81h.77v6.19c-1.81 1.03-5.16 2.06-9.29 2.06-11.61 0-16-7.48-16-18.32Zm0-30.96v-29.93c-6.45 5.16-17.03 8.51-40.51 11.35-27.86 3.35-45.41 8.77-45.41 33.02 0 21.41 18.06 29.15 35.35 29.15 29.93 0 50.57-18.83 50.57-43.6Zm130.29 47.73h-7.74v-94.68c0-22.7-12.64-33.8-32.25-33.8-24.77 0-42.31 18.83-42.31 38.96v89.52h-7.74V75.32h7.74v23.22h.52c7.48-12.9 19.87-25.28 43.08-25.28 19.87 0 32.51 10.32 36.38 27.09h.77c7.22-15.22 22.19-27.09 44.63-27.09 25.28 0 38.96 16.25 38.96 39.99v95.46h-7.74v-94.68c0-22.7-12.13-33.8-32.51-33.8-24.77 0-41.79 17.29-41.79 38.96v89.52Zm109.39-67.08c.26 36.12 18.32 62.69 52.89 62.69 24.25 0 39.73-12.9 45.92-34.83h7.74c-5.16 23.22-23.22 41.79-53.66 41.79-39.47 0-60.63-29.67-60.63-70.17s22.45-68.11 59.6-68.11c13.93 0 25.54 4.39 34.31 11.87 14.71 12.38 21.41 31.99 21.93 56.76h-108.1Zm51.86-61.66c-29.15 0-49.79 21.67-51.6 55.21h99.84c-2.06-35.6-20.9-55.21-48.25-55.21Zm75.34 87.72c2.06 23.48 17.8 36.89 46.18 36.89 26.57 0 41.79-12.13 41.79-30.7s-10.06-25.8-42.83-31.73c-32.25-5.68-47.73-14.71-47.73-35.35s16.25-33.8 44.89-33.8c31.73 0 44.89 16.51 48.25 38.44h-7.74c-2.84-19.09-14.96-31.48-40.51-31.48s-37.15 11.61-37.15 26.83 11.09 22.96 42.57 28.38c32.51 5.68 47.99 14.71 47.99 38.7s-19.35 37.41-49.54 37.41c-35.09 0-52.37-18.58-53.92-43.6h7.74Zm256.97-92.36h7.74V203.8c0 15.48-5.16 28.38-14.96 37.41-9.29 8.51-22.45 13.16-39.99 13.16-32.25 0-50.31-13.16-52.89-32.51h8c3.35 17.03 19.35 25.8 44.63 25.8 32.77 0 47.47-18.58 47.47-43.86v-30.44h-.52c-8.26 21.41-25.03 34.06-49.02 34.06-34.06 0-56.76-26.83-56.76-67.08 0-44.63 26.57-67.34 56.76-67.34 25.54 0 42.05 15.22 49.02 35.6h.52V75.32Zm.51 65.79c0-36.38-18.83-61.15-49.28-61.15-28.12 0-49.79 21.41-49.79 60.63 0 35.6 19.35 60.11 49.54 60.11s49.54-22.96 49.54-59.6Zm35.35.51c.26 36.12 18.32 62.69 52.89 62.69 24.25 0 39.73-12.9 45.92-34.83h7.74c-5.16 23.22-23.22 41.79-53.66 41.79-39.47 0-60.63-29.67-60.63-70.17s22.45-68.11 59.6-68.11c13.93 0 25.54 4.39 34.31 11.87 14.71 12.38 21.41 31.99 21.93 56.76h-108.1Zm51.86-61.66c-29.15 0-49.79 21.67-51.6 55.21h99.84c-2.06-35.6-20.9-55.21-48.25-55.21Zm133.9 2.58c-4.9-.52-9.8-.52-14.71.52-21.16 3.1-35.34 23.48-35.34 42.05v83.59h-7.74V75.32h7.74v27.09h.52c6.97-14.71 18.83-23.48 32.25-25.54 5.93-2.06 12.13-2.32 17.29-1.81v7.48Zm26.32 16.77h.52c7.74-13.42 22.7-26.06 47.99-26.06 26.57 0 41.8 16.25 41.8 39.99v95.46h-8v-94.68c0-22.7-13.42-33.8-35.09-33.8-27.09 0-47.21 18.83-47.21 38.96v89.52h-7.74V24.24h7.74v75.08Zm109.65 42.57c0-38.18 22.7-68.88 60.63-68.88s60.63 30.44 60.63 68.88-22.45 69.4-60.63 69.4-60.63-30.96-60.63-69.4Zm113.26 0c0-37.41-21.93-62.18-52.63-62.18s-52.89 25.03-52.89 62.18 22.19 62.69 52.89 62.69 52.63-25.28 52.63-62.69Zm36.89 66.82h-7.74V24.24h7.74v184.47Zm128.23-32.25h-.26c-8 21.93-26.06 34.83-50.05 34.83-34.06 0-56.76-28.38-56.76-69.14 0-45.67 26.32-69.14 56.5-69.14 22.7 0 42.05 11.87 50.31 35.86h.26V24.24h7.74v184.47h-7.74v-32.25Zm.51-33.79c0-37.67-19.61-62.69-50.05-62.69-28.12 0-49.79 21.41-49.79 62.44 0 36.63 19.35 62.18 49.54 62.18s50.31-23.48 50.31-61.92Z"
            fill="#fff"
          />
        </svg>
        <p className="lead">
          30+ years of professional visual communications career in branding,
          marketing, video production, photography, graphic design, 3D and web
          development.
        </p>
      </Container>

      {/* <Container className="border border-2 border-dark rounded p-5 mt-2">
        <Image src={profile} style={{maxHeight:'100px'}} roundedCircle fluid />


<h1 className="">James Gerhold</h1>
<p className="h5 text-black-50 lh-1">Creative Professional</p>

<p className="lead">30+ years of professional visual  communications career in 
branding, marketing, video production, photography, graphic design and web development.</p>

</Container> */}


{/* <Container fluid className="p-0">
  <Row>
<Col md={4}>
  <Image fluid src="https://cdn.myportfolio.com/9c0c32ffbfb6bec1105e5a0038d455f6/a1b3743f-75c8-49a6-b93a-53b72e811fce_rw_600.jpg?h=710e7944e4896592c45f212ee954ae73" layout="intrinsic" />
</Col>
<Col>
<Image fluid src="https://cdn.myportfolio.com/9c0c32ffbfb6bec1105e5a0038d455f6/db0cb94b-7b2c-4c05-9624-d67b4f242d47_rw_1200.jpg?h=c5264fdc10d95700ebd48739ecb4eb98"></Image>
</Col>

  </Row>
</Container> */}





      {/* ! summary */}

      <Container fluid className="">
        <Row>
          <Col md={4} className="p-5">
            <p className="h4">Summary:</p>
            <p>
              Dynamic and versatile Brand and Creative Director with over 30
              years of experience in multimedia, visual communications, and
              marketing. Proven track record of leading creative teams,
              developing strategic campaigns, and producing high-quality content
              across various media. Adept at collaborating with cross-functional
              teams, managing projects, and enhancing brand presence through
              innovative and cohesive strategies.
            </p>
          </Col>
          <Col md={4} className="p-5">
            <p className="h4">Key Skills:</p>

            <ul>
              <li>Branding and Marketing Strategy</li>
              <li>Creative Direction</li>

              <li>Client Liason</li>
              <li>Video Production and Editing</li>
              <li>Motion Graphics</li>
              <li>Graphic Design and Animation</li>
              <li>Social Media Writing & Creation</li>
              <li>Web Development (HTML5/CSS, React)</li>
              <li>Photography and Photo Editing</li>
              <li>Project Management</li>
              <li>Content Creation</li>
              <li>Collaboration & Teamwork</li>
            </ul>
          </Col>
          <Col md={4} className="p-5">
            <p className="h4">Software Proficiency:</p>
            <ul>
              <li>Adobe Creative Suite</li>
              <li>Visual Studio Code</li>
              <li>Blender3d</li>
              <li>DaVinci Resolve</li>

              <li>Google Web Designer</li>
            </ul>
          </Col>
        </Row>
      </Container>
    </>
  );
}
